import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import UpdatePassword from '../../../components/update-password/update-password'

export class UpdatePasswordPage extends Component {
  constructor(props) {
    super()
  }

  render() {
    return (
      <div>
        <UpdatePassword {...this.props} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  passwordError: state.updatePassword.error,
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(UpdatePasswordPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/update-password-page/update-password-page.js